import { AnyAction } from '@reduxjs/toolkit';

import { Action } from '@reduxjs/toolkit';
import {
  putClientCalculationsByClientIdRequest,
  isClientResponseAction,
} from './clientModel';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import { isNullOrUndefined } from '@shared';
import { AppState } from './store';
import { Dispatch } from 'react';
import { calculateInputHash } from '@shared/calcClientCalculationMetadata';
import { calculationMetadata } from '@shared/calcClientCalculationMetadata';
import { isEmpty } from 'lodash';

function storeClientCalculationsMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (isClientResponseAction(action)) {
    setTimeout(() => storeClientCalculation(dispatch, getStore));
  }
}

export const storeClientCalculationsMiddleware = createSimpleMiddleware(
  storeClientCalculationsMiddlewareImpl,
);

function storeClientCalculation(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const client = getStore().client.data;
  if (isNullOrUndefined(client)) {
    return;
  }

  const clientCalculationMeta = createClientCalculationMetadata(client);
  if (
    isNullOrUndefined(clientCalculationMeta) ||
    isEmpty(clientCalculationMeta)
  ) {
    return;
  }

  dispatch(
    putClientCalculationsByClientIdRequest({
      clientId: client.clientId,
      clientCalculationMeta,
    }),
  );
}

function createClientCalculationMetadata(
  client: Client,
): Record<ClientCalculationType, ClientCalculationMetadata> {
  const newCalculationMeta: Record<
    ClientCalculationType,
    ClientCalculationMetadata
  > = {
    allPhaseCosts: {} as ClientCalculationMetadata,
    combinedFundingSources: {} as ClientCalculationMetadata,
  };
  const timestamp = new Date().toISOString();

  Object.keys(calculationMetadata).forEach(type => {
    const calcType = type as ClientCalculationType;
    const metadata = calculationMetadata[calcType];
    const inputs = metadata.getInputs(client);
    const calculationHash = calculateInputHash(inputs);
    const result = metadata.getResult(client);

    newCalculationMeta[calcType] = {
      calculationHash,
      calculationType: metadata.calculationType,
      version: metadata.version,
      timestamp,
      inputs,
      result,
    };
  });

  return newCalculationMeta;
}
